import { useEffect } from 'react';
import { useNavigate } from 'react-router';

export function RedirectHome() {
  const navigate = useNavigate();

  useEffect(() => {
    navigate('/', { replace: true });
  }, [navigate]);

  return null;
}

export function RedirectClientHome() {
  const navigate = useNavigate();

  useEffect(() => {
    navigate('/client/home', { replace: true });
  }, [navigate]);

  return null;
}
